import type { Location } from './types.js';

export const westAsakusaLocations: Location[] = [
  {
    "id": "pin-1775975952552",
    "number": 1,
    "name": "Shopping Street",
    "nameJa": "",
    "description": "",
    "x": 41.8,
    "y": 58.7,
    "mapsUrl": "https://maps.app.goo.gl/kmeJZNEPQ9PEK3UH7",
    "tip": "Một con phố mang đậm không khí Nhật Bản tại Asakusa, nơi ban ngày nhộn nhịp nhưng buổi tối trở nên yên tĩnh và dễ chụp hơn.\nÁnh đèn trải dọc theo con phố tạo nên khung cảnh rất đặc trưng, phù hợp cho những bức ảnh đêm mang cảm giác cinematic.",
    "allowNight": true,
    "allowSakura": false,
    "allowMomiji": false,
    "allowHot": false,
    "photoOrder": [],
    "hiddenPhotos": [],
    "isShop": false,
    "photos": [],
    "tipTranslations": {
      "en": "A street full of Japanese atmosphere in Asakusa. It is busy during the day but becomes quiet and easy to shoot in the evening.\nThe lights along the street create a very distinctive scene, perfect for cinematic night photos."
    }
  },
  {
    "id": "pin-1775976117752",
    "number": 2,
    "name": "Hanayashiki Street",
    "nameJa": "",
    "description": "",
    "x": 41.9,
    "y": 45.1,
    "mapsUrl": "https://maps.app.goo.gl/KnLiVfb6nUoELUba7",
    "tip": "Cửa vào khách sạn Onyado Nono Asakusa là một góc chụp mang đậm nét truyền thống. Khu vực Hanayashiki Street xung quanh cũng có không khí cổ kính, gợi cảm giác như một con phố nhỏ ở Kyoto.\nCó thể chụp đẹp cả vào buổi sáng lẫn buổi tối, mỗi thời điểm mang lại một cảm giác khác nhau.\nDọc theo con phố có nhiều góc chụp đa dạng, như với đèn lồng lớn hoặc các mặt tiền kiến trúc truyền thống.",
    "allowNight": true,
    "allowSakura": false,
    "allowMomiji": false,
    "allowHot": false,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/West/2/drive_6ESdZwA2_1775976988.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/West/2/drive_-gi9rdcI_1775976658.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/West/2/drive_LUgGkq_s_1775976993.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/West/2/drive_Y62gEADc_1775976655.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/West/2/drive_-09OGmfy_1775976627.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/West/2/drive_98cd2XfL_1775976660.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/West/2/drive_Aa_3QRji_1775976684.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/West/2/drive_EfaTCoci_1775976749.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/West/2/drive_rdXIBSyf_1775976747.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/West/2/drive_vIjiioYH_1775976995.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/f_auto,q_auto,w_1200/kra-asakusa/West/2/drive_ZjL3ruEA_1775976990.jpg"
    ],
    "hiddenPhotos": [],
    "isShop": false,
    "photos": [],
    "tipTranslations": {
      "en": "The entrance of the Onyado Nono Asakusa hotel is a spot full of traditional character. The Hanayashiki Street area around it also has an old-town feel, like a small street in Kyoto.\nIt looks good both in the morning and in the evening, and each time of day gives a different mood.\nAlong the street there are many different angles, such as the big lanterns or the traditional building fronts."
    }
  }
];
